/**
 * Validates and returns a safe URL, or undefined if the URL is potentially malicious.
 *
 * Allows:
 * - Relative paths (starting with /)
 * - HTTP/HTTPS URLs
 *
 * Blocks:
 * - javascript: URLs
 * - data: URLs
 * - Other potentially dangerous schemes
 */
export function safeUrl(maybeSafeUrl: string | undefined | null): string | undefined {
  if (!maybeSafeUrl) {
    return undefined
  }

  const trimmed = maybeSafeUrl.trim()

  // Allow relative paths
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
    return trimmed
  }

  // Parse and validate absolute URLs
  try {
    const parsed = new URL(trimmed)
    const protocol = parsed.protocol.toLowerCase()

    // Only allow http and https schemes
    if (protocol === 'https:' || protocol === 'http:') {
      return trimmed
    }
  } catch {
    // Invalid URL format
  }

  return undefined
}
